import Vue from 'vue';
import './axiosInterceptorFix';
import axios, { AxiosRequestConfig } from 'axios';
import * as _ from 'lodash';

axios.interceptors.request.use(
  function requestInterceptor(config: AxiosRequestConfig) {
    if (config) {
      const method = config.method ? config.method.toUpperCase() : '???';
      const url =
        config.baseURL && config.url && !config.url.startsWith(config.baseURL)
          ? `${config.baseURL}/${config.url}`
          : config.url;
      Vue.$log.debug(`>>> ${method} ${url}`, _.omit(config, ['baseURL', 'url', 'method']));
      (config as any).startTime = Date.now();
    }
    return config;
  },
  function(error) {
    Vue.$log.warn('<<< HTTP request error', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    if (response) {
      const config = response.config;
      if (config) {
        const elapsed = Date.now() - (config as any).startTime;
        const method = config.method ? config.method.toUpperCase() : '???';
        const url =
          config.baseURL && config.url && !config.url.startsWith(config.baseURL)
            ? `${config.baseURL}/${config.url}`
            : config.url;
        Vue.$log.debug(
          `<<< ${method} ${response.status} ${elapsed}ms ${url}`,
          _.omit(response, ['config']),
          response.config
        );
      } else {
        Vue.$log.debug('<<<', response);
      }
    }
    return response;
  },
  function(error) {
    if (error) {
      const config = error.config;
      const response = error.response;
      if (config) {
        const elapsed = Date.now() - (config as any).startTime;
        const status = (error.response && error.response.status) || '';
        const method = config.method ? config.method.toUpperCase() : '???';
        const url =
          config.baseURL && config.url && !config.url.startsWith(config.baseURL)
            ? `${config.baseURL}/${config.url}`
            : config.url;
        Vue.$log.warn(`<<< ${method} ${status || '###'} ${elapsed}ms ${url}`, error, response);
      } else {
        Vue.$log.debug('<<<', error);
      }
    } else {
      Vue.$log.debug('<<<', error);
    }
    return Promise.reject(error);
  }
);
